import { secondAxios } from "../../../../../api/axios";

const PV_BASE = "/pressure_vessel";

function encodeParam(value) {
  return encodeURIComponent(String(value ?? ""));
}

// -------------------------
// Projects
// -------------------------

export async function getProjects() {
  const res = await secondAxios.get(`${PV_BASE}/getProjects`);
  return res.data;
}

export async function createPressureVesselProject({
  projectName,
  type,
  equipmentName,
  rev,
  data,
}) {
  if (!projectName) throw new Error("projectName is required");
  if (!type) throw new Error("type is required");
  if (!equipmentName) throw new Error("equipmentName is required");
  if (!rev) throw new Error("rev is required");

  const res = await secondAxios.post(
    `${PV_BASE}/create/${encodeParam(projectName)}/${encodeParam(
      type,
    )}/${encodeParam(equipmentName)}/${encodeParam(rev)}`,
    data,
  );

  return res.data;
}

export async function getPressureVesselFile({
  projectName,
  type,
  equipmentName,
  rev,
}) {
  if (!projectName) throw new Error("projectName is required");
  if (!type) throw new Error("type is required");
  if (!equipmentName) throw new Error("equipmentName is required");
  if (!rev) throw new Error("rev is required");

  const res = await secondAxios.get(
    `${PV_BASE}/getFile/${encodeParam(projectName)}/${encodeParam(
      type,
    )}/${encodeParam(equipmentName)}/${encodeParam(rev)}`,
  );

  return res.data;
}

export async function generateLink({
  projectName,
  type,
  equipmentName,
  rev,
}) {
  if (!projectName) throw new Error("projectName is required");
  if (!type) throw new Error("type is required");
  if (!equipmentName) throw new Error("equipmentName is required");
  if (!rev) throw new Error("rev is required");

  const res = await secondAxios.get(
    `${PV_BASE}/generateLink/${encodeParam(projectName)}/${encodeParam(
      type,
    )}/${encodeParam(equipmentName)}/${encodeParam(rev)}`,
  );

  return res.data;
}

// -------------------------
// Tasks
// -------------------------

export async function getTaskList() {
  const res = await secondAxios.get(`${PV_BASE}/getTaskList`);
  return res.data;
}

export async function addToTasks(data) {
  const res = await secondAxios.post(`${PV_BASE}/addToTasks`, data);
  return res.data;
}

export async function createShellTasks(data) {
  const res = await secondAxios.post(`${PV_BASE}/createShellTasks`, data);
  return res.data;
}

// -------------------------
// Calculations
// -------------------------

export async function calculate(data) {
  const res = await secondAxios.post(`${PV_BASE}/calculate`, data);
  return res.data;
}

export async function calculateShell(data) {
  const res = await secondAxios.post(`${PV_BASE}/calculateShell`, data);
  return res.data;
}

export async function calculateNozzle(data) {
  const res = await secondAxios.post(`${PV_BASE}/calculateNozzle`, data);
  return res.data;
}

// -------------------------
// Estimation
// -------------------------

export async function estimationTable(data) {
  const res = await secondAxios.post(`${PV_BASE}/estimateAll`, data);
  return res.data;
}

export async function estimateShell(data) {
  const res = await secondAxios.post(`${PV_BASE}/estimate`, data);
  return res.data;
}

export async function estimateNozzle(data) {
  const res = await secondAxios.post(`${PV_BASE}/estimateNozzle`, data);
  return res.data;
}

export async function estimateSaddle(data) {
  const res = await secondAxios.post(`${PV_BASE}/estimateSaddle`, data);
  return res.data;
}

export async function estimateCost() {
  const res = await secondAxios.post(`${PV_BASE}/estimateCost`);
  return res.data;
}

// -------------------------
// Material Data
// -------------------------

export async function getSingleMaterialData(data) {
  const res = await secondAxios.post(`${PV_BASE}/materialData`, data);
  return res.data;
}

export async function materialControlData(data) {
  const res = await secondAxios.post(`${PV_BASE}/MaterialControlData`, data);
  return res.data;
}

export async function getAllMaterialTables() {
  const res = await secondAxios.get(`${PV_BASE}/tables/all`);
  return res.data;
}

export async function getMaterialTable(table) {
  if (!table) {
    throw new Error("table is required");
  }

  const res = await secondAxios.get(`${PV_BASE}/tables/${encodeParam(table)}`);
  return res.data;
}

// -------------------------
// Download
// -------------------------

export async function downloadPressureVesselFile() {
  const res = await secondAxios.get(`${PV_BASE}/download`, {
    responseType: "blob",
  });

  return res.data;
}

export async function downloadLogs() {
  const res = await secondAxios.get(`${PV_BASE}/downloadlogs`);
  return res.data;
}

// -------------------------
// Punchlist
// -------------------------

export async function getPunchList(equipId) {
  if (!equipId) {
    throw new Error("equipId is required");
  }

  const res = await secondAxios.get(
    `${PV_BASE}/punchlist/${encodeParam(equipId)}`,
  );

  return res.data;
}

export async function updatePunchlist(equipId, data) {
  if (!equipId) {
    throw new Error("equipId is required");
  }

  const res = await secondAxios.post(`${PV_BASE}/punchlist/update`, {
    equipId,
    data,
  });

  return res.data;
}

export async function newPunchlist(equipId, data) {
  if (!equipId) {
    throw new Error("equipId is required");
  }

  const res = await secondAxios.post(`${PV_BASE}/punchlist/new`, {
    equipId,
    data,
  });

  return res.data;
}

// -------------------------
// Realtime
// -------------------------

export async function getRealtimeData() {
  const res = await secondAxios.get(`${PV_BASE}/realtime`);
  return res.data;
}

export async function addRealtimeData(data) {
  const res = await secondAxios.post(`${PV_BASE}/realtime`, data);
  return res.data;
}

// -------------------------
// Documents
// -------------------------

export async function getDocumentsData() {
  const res = await secondAxios.get(`${PV_BASE}/get-documents`);
  return res.data;
}